import React from 'react';
import { Box, Card, CardContent, Divider, Grid2 as Grid, Link, Typography} from '@mui/material';
import Main from '../../layouts/Main';
import Container from '../../components/Container';
import DatasetIcon from '@mui/icons-material/Dataset';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PageBreadCrumbs from '../../components/PageBreadcrumbs';

const reportsList =[
    {
        category: 'Candidate Reports',
        reports: [
          {
            title: 'Legislative Full Year Activity Summaries',
            link: '/Reports/LegFullYearReports',
          },
          {
            title: 'Legislative Races',
            link: '/Reports/LegislativeRaces',
          },
          {
            title: 'Special Elections',
            link: '/Reports/SpecialElections',
          },
          {
            title: 'Statewide Candidates Year-to-Date Reports',
            link: '/Reports/StatewideReports',
          },
          {
            title: 'Mayoral Year-to-Date Reports',
            link: '/Reports/MayoralReports',
          },
          {
            title: 'City Council Candidates (Cities over 65k) Year-to-Date Reports',
            link: '/Reports/CityCouncilReports',
          },
          {
            title: 'County / District Candidates Year-to-Date Reports',
            link: '/Reports/CountyReports',
          }
        ],
      },
      {
        category: 'Non-Candidate Filer Reports',
        reports: [
          {
            title: 'PAC Reports',
            link: '/Reports/PacReports',
          },
          {
            title: 'Ballot Question Reports',
            link: '/Reports/BallotQuestionReports',
          },
          {
            title: 'Active Ballot Question Committee Reports',
            link: '/Reports/ActiveBallotQuestionReports',
          },
          {
            title: 'State Party Reports',
            link: '/Reports/StatePartyReports',
          },
          {
            title: 'Local Party Reports',
            link: '/Reports/LpcReports',
          },
          {
            title: 'Segregated Funds',
            link: '/Reports/SegregatedFunds',
          },
        ],
      },
      {
        category: 'Independent Spending Reports',
        reports: [
          {
            title: 'IEPAC Reports',
            link: '/Reports/IndependentExpenditurePacReports',
          },
          {
            title: 'Independent Expenditure Reports',
            link: '/Reports/IndependentExpenditures',
          },
          {
            title: 'Electioneering Communications',
            link: '/Reports/ElectioneeringCommunications',
          },
          {
            title: 'Independent Ballot Question Spending',
            link: '/Reports/BallotQuestionSpendingReports',
          },
        ],
      },
      {
        category: 'Miscellaneous Reporting',
        reports: [
          {
            title: 'Casino Ballot Question Spending Reports',
            link: '/Reports/CasinoBallotQuestionSpending',
          },
          {
            title: 'Political Spending Reports of Other Groups and Associations',
            link: '/Reports/GroupPoliticalSpending',
          }
        ],
      },
]

const Reports = (): JSX.Element => {
  
  document.title = 'OCPF - Campaign Finance Reports';

    const renderReportBox = (title = '', link='') => (
        <Box
          component={Card}
          variant={'outlined'}
          bgcolor={'transparent'}
          sx={{
            cursor: 'pointer',
            '&:hover': {
              boxShadow: 2,
            },
          }}
        >
          <CardContent>
            <Box
              display={'flex'}
              flexDirection={"row"}
              flex={'1 1 100%'}
              justifyContent={"left"}
              alignItems={"left"}
            >
              <DatasetIcon />
              <Link href={link} underline="none" marginLeft={1} fontWeight={550}>
                    {title}
              </Link>
            </Box>
          </CardContent>
        </Box>
      );

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
      <Box>
        <Typography
            variant="h5"
            align={'left'}
            data-aos={'fade-up'}
            gutterBottom
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            marginBottom={2}
            >
            Campaign Finance Reports <Typography component={"span"} variant="subtitle2" color="text.secondary">filed with OCPF</Typography>
        </Typography>
        <Divider/>
      <Grid container spacing={4} marginTop={2}>
        <Grid size={{xs:12, md:6}} marginTop={1}>
          <Box
            component={Card}
            variant={'outlined'}
            bgcolor={'transparent'}
            sx={{
              cursor: 'pointer',
              '&:hover': {
              boxShadow: 2,
            },
            }}
          >
          <CardContent>
            <Box
              display={'flex'}
              flexDirection={"row"}
              flex={'1 1 100%'}
              justifyContent={"left"}
              alignItems={"left"}
            >
              <AssessmentIcon color='success' />
              <Link href={'/Reports/log'} underline="none" marginLeft={1} fontWeight={550}>
                  Report Filings: Real Time E-Filed Reports
              </Link>
            </Box>
          </CardContent>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={4} marginTop={2}>
        {
            reportsList.map((list, i) => (
                <Grid size={{xs:12, md:6}} key={i} marginTop={1}>
                    <Box marginBottom={2}>
                        <Typography variant={'h6'} fontWeight={700} gutterBottom>
                            {list.category}
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        {list.reports.map((report, index) => (
                        <Grid size={12} key={index}>
                            {renderReportBox(report.title, report.link)}
                        </Grid>
                     ))}
                </Grid>
              </Grid>
            ))
        }
      </Grid>
    </Box>
    </Container>
    </Main>
  );
};

export default Reports;
